export const CREATE_SALES_PAYMENT = "CREATE_SALES_PAYMENT";
export const FETCH_SALES_PAYMENTS = "FETCH_SALES_PAYMENTS";
export const FETCH_SALES_PAYMENT = "FETCH_SALES_PAYMENT";
export const EDIT_SALES_PAYMENT = "EDIT_SALES_PAYMENT";
export const DELETE_SALES_PAYMENT = "DELETE_SALES_PAYMENT";
